

import { ButtonGroup, ImageGalleryMain, TextEditorForContentBlocks } from 'components/molecules';
import React, { FC } from 'react';
import { TButtonAlignmentProps, TButtonItemProps } from 'types';
import { useDeviceClassification } from 'utils';
import styles from "../ContentBlocks.module.css";

type TTextEditorWithImageGalleryBlockProps = {
    TextEditor1: string;
    ImagePool: any[];
    ShowSidebar: boolean;
    TextEditor2: string;
    ContentAlignment: any;
    BackgroundColour: { Value: string };
    BlockColumn: number;
    ShowImageCaptions: boolean;
    ButtonSelection1: TButtonItemProps[];
    ButtonSelection2: TButtonItemProps[];
    ButtonAlignment1: TButtonAlignmentProps;
    ButtonAlignment2: TButtonAlignmentProps;
}
const getAlignment = (str) => {
    enum options {
        'right' = 'flex-end',
        'left' = 'flex-start',
        'center' = 'center'
    }

    const r = options[str];

    return r ? r : 'flex-start';
}

export const TextEditorWithImageGalleryBlock: FC<TTextEditorWithImageGalleryBlockProps> = ({
    TextEditor1,
    ImagePool,
    TextEditor2,
    ContentAlignment,
    BackgroundColour,
    BlockColumn,
    ShowImageCaptions,
    ShowSidebar,
    ButtonSelection1,
    ButtonSelection2,
    ButtonAlignment1,
    ButtonAlignment2
}) => {

    const { isDesktop } = useDeviceClassification();

    return (
        <div
            className="animateonscroll"
            style={{
                width: '100vw',
                background: BackgroundColour?.Value ? BackgroundColour.Value : "#FFFFFF"
            }}>

            <div style={{
                width: '85%',
                maxWidth: '1280px',
                margin: '0 auto',
                display: 'flex',
                justifyContent: ShowSidebar ? getAlignment(ContentAlignment?.Class) : 'center'
            }} >
                <div className={styles.TextEditorWithImageGalleryBlock_Wrapper} style={{
                    width: isDesktop ? `calc((100% / 12 * ${BlockColumn}) + (40px / 12 * ${BlockColumn}) - 40px)` : '100%'
                }}>
                    <TextEditorForContentBlocks className="ContentBlock c-block" data={TextEditor1} />
                    {ImagePool && ImagePool.length > 0 &&
                        <ImageGalleryMain
                            ShowCaptions={ShowImageCaptions}
                            noArrows
                            large
                            images={ImagePool}
                        />}
                    {Boolean(TextEditor2) && <TextEditorForContentBlocks data={TextEditor2} />}

                    {Boolean(ButtonSelection1?.length) && <ButtonGroup
                        alignment={ButtonAlignment1}
                        buttons={ButtonSelection1} />}

                    {Boolean(ButtonSelection2?.length) && <ButtonGroup
                        alignment={ButtonAlignment2}
                        buttons={ButtonSelection2} />}
                </div>
            </div>
        </div>
    )
}


